import React from "react";
import PropsElement from "./PropsElement";
import PopupWrapper from "components/common/PopupWrapper";

class PropsPopover extends React.PureComponent {
  render() {
    const {
      item,
      triggerElement,
      titleElement,
      place = "bottom",
      name,
      resourceType,
    } = this.props;

    return (
      <PopupWrapper
        place={place}
        triggerType="click"
        hideArrow={false}
        triggerElement={triggerElement}
        onOpen={this.props.onOpen}
        onClose={this.props.onClose}
        popupElement={
          <div className="shadow border p-4">
            <div className="border-b mb-1 pb-1 font-semibold text-gray-900">
              {titleElement ? (
                titleElement
              ) : (
                <>
                  Props: {item.externalId} - {item.name}
                </>
              )}
            </div>
            <PropsElement item={item} resourceType={resourceType} />
          </div>
        }
      ></PopupWrapper>
    );
  }
}

export default PropsPopover;
